import { Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constants
import { choicesUserType, getOrderStatus } from '../../../constants';
//stores
import { useUserStore } from 'stores';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import Select from 'components/backoffice/selects/SelectCustom';
import SearchCompanyInput from 'components/backoffice/customInput/SearchCompanyInput';
import { SelectInputCustom } from 'components/input';

const FiltersTableOrders = ({ formFilter, handleClear, setFormFilter, t, page, setPage }) => {
  const { profile, benefitedBookstore } = useUserStore();
  const choices = [{
    id: '',
    value: t('faqs.none')
  }, ...getOrderStatus(t)];

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear} className="w-100">
      <Form className="form-filter-list filters-table-orders">
        <Row className="g-3">
          {profile !== 'library' && (
            <Col xl={3} lg={6} md={12} xs={12}>
              <Form.Label className="text-light filters-table-orders__label" title={t('tipousuario')}>
                {t('tipousuario')}
              </Form.Label>
              <Select
                placeholder={t('userTypes')}
                title={t('userTypes')}
                value={formFilter.usertype}
                onCheckedItem={(e) => handleSearch(e, 'usertype')}
                choices={choicesUserType(t, true)}
              />
            </Col>
          )}
          <Col xl={profile === 'library' ? 3 : 3} lg={6} md={12} xs={12}>
            <Form.Label className="text-light filters-table-orders__label" title={t('state')}>
              {t('state')}
            </Form.Label>
            <SelectInputCustom
              placeholder={t('orderTrans.selectOrderStatus')}
              title={t('orderTrans.selectOrderStatus')}
              value={formFilter.order_status}
              onCheckedItem={(e) => handleSearch(e, 'order_status')}
              choices={choices}
            />
          </Col>
        {/*   {profile !== 'library' && (
            <Col xl={3} lg={6} md={12} xs={12}>
              <Form.Label className="text-light filters-table-orders__label" title={t('benefitedbookstore')}>
                {t('benefitedbookstore')}
              </Form.Label>
              <SearchCompanyInput
                label={t('benefitedbookstore')}
                onSelected={(item) => handleSearch(item, 'benefited_company')}
                defaultCompany={formFilter.benefited_company}
                hasLabel={false}
                placeholder={t('searchByBookstore')}
                className="orders m-0"
              />
            </Col>
          )} */}
          <Col xl={profile === 'library' ? 3 : 3} lg={6} md={12} xs={12}>
            <Form.Label className="text-light filters-table-orders__label" title={t('order')}>
              {t('order')}
            </Form.Label>
            <CustomInput
              handleKeyDown={true}
              type="text"
              placeholder={t('searchByOrder')}
              title={t('searchByOrder')}
              value={formFilter.code}
              onChange={(e) => handleSearch(e, 'code')}
              icon={<BsSearch color="#161A25" className="icon-search" />}
            />
          </Col>
          <Col xl={profile === 'library' ? 3 : 3} lg={6} md={12} xs={12}>
            <Form.Label className="text-light filters-table-orders__label" title={t('user')}>
              {t('user')}
            </Form.Label>
            <CustomInput
              handleKeyDown={true}
              type="text"
              placeholder={t('searchByEmailUsername')}
              title={t('searchByEmailUsername')}
              value={formFilter.search}
              onChange={(e) => handleSearch(e, 'search')}
              icon={<BsSearch color="#161A25" className="icon-search" />}
            />
          </Col>
        </Row>
      </Form>
    </SearchTable>
  )
}

FiltersTableOrders.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableOrders;